function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "x2");

function SvgIcnTimes2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.24 28.73)",
    style: {
      fill: "#5e5e5d",
      fontSize: 24,
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTimes2);
export default __webpack_public_path__ + "static/media/icn-times2.aad988335194b7a3e69ecb08ce5629bf.svg";
export { ForwardRef as ReactComponent };